<template>
  <div class="outline">
    <div class="leftRow">
      <div class="body">
        <img src="@/assets/image/logo.png" class="middleImg" />
        <div style="margin:4.444vh 0px 0px 3.0208vw;height:9.259vh">
          <div style="float:left">
            <div class="english">ABOUT US</div>
          </div>
          <div class="chinese">概况</div>
        </div>
        <!-- 底部 -->
        <div class="footerMenu"  style="margin-left:1.71875vw">
          <div
            :class="classNameC"
            @mouseover="classNameC = 'colAHover'"
            @mouseout="classNameC = 'colA'"
            @click="openTypeLise(2)"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">风</div>
            <div class="chaFont">景</div>
            <div class="chaFont">名</div>
            <div class="chaFont">山</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
          <div
            :class="classNameD"
            @mouseover="classNameD = 'colAHover'"
            @mouseout="classNameD = 'colA'"
            @click="openTypeLise(1)"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">走</div>
            <div class="chaFont" style="margin-top:0px">进</div>
            <div class="chaFont" style="margin-top:0px">武</div>
            <div class="chaFont" style="margin-top:0px">夷</div>
            <div class="chaFont" style="margin-top:0px">山</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopButtom from "@/components/common/TopButtom.vue";
import Banner from "../../components/common/banner";
import  "@/css/switch.css"
export default {
  name: "OutLine",
  components: { Banner, TopButtom },
  data() {
    return {
      classNameA: "colA",
      classNameB: "colA",
      classNameC: "colA",
      classNameD: "colA"
    };
  },
  methods: {
    openTypeLise(type) {
      let name = "";
      if (type == 1) {
        name = "TabApage";
      } else if (type == 2) {
        name = "TabBpage";
      } else if (type == 3) {
        name = "TabCpage";
      } else if (type == 4) {
        name = "TabDpage";
      }
      this.$store.commit("setChildMenu",2);
      this.$store.commit("setShowSwitchMenu", false);
      this.$store.commit("setTabPage", type);
      this.$emit("specialtyListFunction", name);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/outline/outlineSwitch.vue